<template>
  <div class="latestposts">
    <div v-for="post in posts">
      <div style="position:relative;">
        <h3 v-html="post.title.rendered">{{ post.title.rendered }}</h3>
        <div class="text-muted mb-2">{{ post.date | moment("dddd, MMMM D, YYYY") }} at {{ post.date | moment("h:mm a") }}</div>
        <div v-html="post.excerpt.rendered">{{ post.excerpt.rendered }}</div>
        <router-link :to="{ name: 'post', params: { slug: post.slug }}" class="stretched-link">Continue reading</router-link>

        <hr>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      posts: [],
      errors: [],
      currpage: 1
    }
  },
  props: {
    currentpage: Number
  },
  watch: {
    currentpage(newcurrentpage) {
      this.getCurrentPage(newcurrentpage);
    }
  },
  methods: {
    getLatestPosts() {
      axios.get('https://wpapi.sharenote.com/wp-json/wp/v2/posts?per_page=5&page=' + this.currpage)
      .then(response => {
        this.posts = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    getCurrentPage(page) {
      if (page < 1) {
        this.currpage = 1
      } else {
        this.currpage = page
      }
    }
  },
  created() {
    this.getLatestPosts()
  }
}
</script>
